import * as actionType from "./Action_Type";
import { CALL_API } from "../Middlewares/api";
import { generatePsw } from "../Utils/PwsUtils";
import { sortList } from "../Utils/Sorting";
import * as SGUri from "../Utils/PagesSwitch.js";
import { USER_GET_LIST, USER_REGISTER } from "../Utils/Strings/Service_Endpoint";
import { refreshList, requestList } from "./Action_Utils.js";

export function getOperatoriList(filter) {
  var obj = {
    LockoutEnabled : filter.LockoutEnabled,
    EmailConfirmed : filter.EmailConfirmed,
    Email          : filter.Email,
    Username       : filter.Username,
    PhoneNumber    : filter.PhoneNumber,
    IDHolding      : filter.IDHolding,
    IDAzienda      : filter.IDAzienda,
    IDRole         : filter.IDRole
  };
  return {
    [CALL_API]: {
      endpoint: USER_GET_LIST+SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_OPERATORI_LIST_REQUEST,
        actionType.SERVICE_OPERATORI_LIST_SUCCESS,
        actionType.SERVICE_OPERATORI_LIST_ERROR
      ]
    }
  };
}

export const orderListaOperatori = (holdList, value) => {
  return dispatch => {
     dispatch(refreshList(sortList(holdList, value), actionType.SERVICE_OPERATORI_REFRESH_LIST));
   }
}

export function setOperatore(operatore) {
  var pwsGenerata = generatePsw(8);

  var obj = {
    Username         : operatore.Username,
    Email            : operatore.Email,
    Password         : operatore.Password  || pwsGenerata,
    ConfirmPassword  : operatore.Password  || pwsGenerata,
    Role             : operatore.Role == null ? null : operatore.Role.ID,
    IDHoldingAzienda : operatore.IDAzienda || operatore.IDHolding
  };

  return {
    [CALL_API]: {
      endpoint: USER_REGISTER,
      authenticated: true,
      types: [
        actionType.SERVICE_OPERATORI_ADD_REQUEST,
        actionType.SERVICE_OPERATORI_ADD_SUCCESS,
        actionType.SERVICE_OPERATORI_ADD_ERROR
      ],
      method : "POST",
      data : SGUri.serializeParametersPOST(obj),
    }
  };
}

export const showAddOperatore = () => ({
  type: actionType.SERVICE_OPERATORI_OPEN_ADD_DIALOG
});

export const hideAddOperatore = () => ({
  type: actionType.SERVICE_OPERATORI_CLOSE_ADD_DIALOG
});

export const setUsernameError = (error) => ({
  type  : actionType.SERVICE_CHECK_USERNAME_ERROR,
  error : error
});



// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Operatori.js